require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-appeal-of-the-inner-north.json") })
        }
      }, "path---news-appeal-of-the-inner-north");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-appeal-of-the-inner-north!./.cache/json/news-appeal-of-the-inner-north.json
// module id = 788
// module chunks = 231608221292675